export type ConsentCategory =
	| "necessary"
	| "analytics"
	| "marketing"
	| "preferences";

export type ConsentChoices = {
	necessary: true;
	analytics: boolean;
	marketing: boolean;
	preferences: boolean;
};

export type ConsentRecord = {
	version: number;
	choices: ConsentChoices;
	updatedAt: string;
};

export const CONSENT_VERSION = 1;
export const CONSENT_STORAGE_KEY = "ld_consent";
export const CONSENT_COOKIE_NAME = "ld_consent";
export const CONSENT_EVENT = "ld:consent-changed";

export const ALL_GRANTED: ConsentChoices = {
	necessary: true,
	analytics: true,
	marketing: true,
	preferences: true,
};

export const ONLY_NECESSARY: ConsentChoices = {
	necessary: true,
	analytics: false,
	marketing: false,
	preferences: false,
};
